import React from "react";
import BodyCell from "./components/BodyCell";
// import BodyCellSettings from "./components/BodyCellSettings";

export default () => {
  return {
    name: 'bodyCell',
    group: '',
    target: ["headerCell"],
    title: '',
    data: {
      settings: {
        margin: {
          desktop: { all: 0 },
          mobile: { all: 0 }
        },
        padding: {
          desktop: { all: 0 },
          mobile: { all: 0 }
        },
      },
      renderSettings: {
        renderType: 'Div', // Div Button Icon Link Badge Tag
      },
    },
    pluginComponent: BodyCell, // 插件渲染组件
    pluginSettingComponent: null, // 插件设置项组件
  }
}
